import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDoAndDont24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconDoAndDont24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 8.436a4.936 4.936 0 1 1 9.773.993 6.4 6.4 0 0 0-1.7.934l-.01-.01-1.795-1.795 1.717-1.718a.75.75 0 0 0-1.06-1.06L8.707 7.497 6.99 5.78a.75.75 0 1 0-1.06 1.06l1.717 1.718-1.718 1.717a.75.75 0 1 0 1.06 1.061l1.718-1.718 1.788 1.788a6.4 6.4 0 0 0-1.062 1.866q-.483.1-.997.1A4.936 4.936 0 0 1 3.5 8.436m5.576 6.405q-.316.03-.64.031a6.436 6.436 0 1 1 6.405-5.8q.316-.032.64-.032a6.436 6.436 0 1 1-6.405 5.8m1.47.635a4.936 4.936 0 1 1 9.872 0 4.936 4.936 0 0 1-9.873 0m8.347-1.884a.75.75 0 0 1 0 1.06L15.045 18.5l-.53.53-.53-.53-1.915-1.914a.75.75 0 1 1 1.06-1.06l1.385 1.383 3.317-3.317a.75.75 0 0 1 1.061 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDoAndDont24);
